const CHILDISH_TAG = "BlockDemoWithChildTheme";
function filterChildishGames(games) {
  const filteredMap = new Map();
  for (const [id, game] of Array.from(games.entries())) {
    if (!isChildishGame(game)) {
      filteredMap.set(id, game);
    }
  }
  return filteredMap;
}
function isChildishGame(game) {
  return game && game.igcTags.includes(CHILDISH_TAG);
}
function filterAuthRequiredGames(games) {
  const filteredMap = new Map();
  for (const [id, game] of Array.from(games.entries())) {
    if (!game.authRequired) {
      filteredMap.set(id, game);
    }
  }
  return filteredMap;
}

export { CHILDISH_TAG, filterAuthRequiredGames, filterChildishGames, isChildishGame };
